import { useCallback } from 'react';
import { buildShareLink, copyToClipboard } from '@/shared/utils/clipboard';

export function useCopyShareLink(): {
  copyLink: (shareId: string) => void;
} {
  const copyLink = useCallback((shareId: string): void => {
    copyToClipboard(buildShareLink('candidate', shareId));
  }, []);

  return { copyLink };
}
